import script from "./RequestsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestsView.vue?vue&type=script&setup=true&lang=ts"

import "./RequestsView.vue?vue&type=style&index=0&id=6c706f6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c706f6c"]])

export default __exports__